import { Action, applyMiddleware, createStore as originalCreateStore, Store, Middleware } from 'redux';
import sagaMiddlewareFactory from 'redux-saga';
import { enableBatching } from 'redux-batched-actions';

import { CheckinState, rootReducer } from './reducers';
import memes from '../../../memes';
import { rootSaga } from './sagas';

export const createStore = memes(
	(): Store<CheckinState> => {
		const saga = sagaMiddlewareFactory();
		const middleware: Middleware[] = [saga];

		if (process.env.NODE_ENV === 'development') {
			middleware.push(require('redux-logger').default);
		}

		const store = originalCreateStore<CheckinState, Action, {}, {}>(
			enableBatching(rootReducer),
			applyMiddleware(...middleware)
		);

		saga.run(rootSaga);

		return store;
	}
);
